import { render, staticRenderFns } from "./ClientePadrao.vue?vue&type=template&id=92c95dfe&scoped=true&"
import script from "./ClientePadrao.vue?vue&type=script&setup=true&lang=js&"
export * from "./ClientePadrao.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c95dfe",
  null
  
)

export default component.exports